export default function Name() {
    return (
        <div className="name-container">
            <h2 className="name">Zachary Lipscomb</h2>
            <h4 className="dev-type">Full-Stack-Developer</h4>
            <h6 className="website">ezmanagers.com</h6>
        </div>
    )
}